export default __webpack_public_path__ + "static/media/cvv.afc039b3.svg";